// extracted by mini-css-extract-plugin
module.exports = {"notFound":"styles_notFound__3TLwL","fullViewHeight":"styles_fullViewHeight__3EszT","headline":"styles_headline__2UTSA","description":"styles_description__2mFkW"};